import { useEffect, useMemo, useRef, useState } from "react"
import { Graph_QL, useGetAutopig, useGetDomainLog } from "../../../Services/Agrisys_GqlDataCaller"
import { useTranslation } from 'react-i18next';
import { colors, css, fonts, frames, glyphs } from "../../../Styles";
import { Button, ButtonList, NewCreatableSelect, NewInput, NewInputList, NewInputListHandles, NewSelect, NewSelectHandles } from "../../../Components";
import PageHeader from "../../../Components/BaseComponents/pageHeader";
import { ButtonTypes, ListStyle_Types, NewFieldStyles } from "../../../Definitions";
import { Log_Item } from "../../../Services/Agrisys_GqlDataCaller/DeviceCalls/DeviceSlices/logSlice";
import { Pages } from "../../../Navigation/Routers/root";
import { useLanControllers } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useLanControllers";
import { useAppSelector } from "../../../Store";
import { LanControllerLogArgs, LanControllerLogResponse } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLanControllerLogs";

// #region | ViewBlocks Logs and Data
function DefaultViewBlock() {
  return (
    <div>
      Hey
    </div>
  )
}

interface LogViewBlock_Props {
  LogData: [string, Log_Item]
}

function LogViewBlock({LogData}:LogViewBlock_Props) {
  return (
    <div>
      {LogData[1].data.map((logItem, index) => (
        <div key={index}>
          {logItem.message.split('\n').map((line, lineIndex) => (
            <p key={lineIndex}>{line}</p> // Each line in a separate <p> element
          ))}
        </div>
      ))}
    </div>
  )
}

interface ControllerLog_Props {
  LogData: LanControllerLogArgs[] //todo: correvt type
}

function ControllerLogViewBlock({LogData}:ControllerLog_Props) {
  console.log("test", LogData)
  return (
    <div style={{width: "fit-content"}}>
      {[...LogData].sort((a: LanControllerLogArgs, b: LanControllerLogArgs) => b.timestamp - a.timestamp).map((logItem: LanControllerLogArgs, index: number) => (
        <div key={index} style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary, display: "grid", gridTemplateColumns: "repeat(4, 1fr)", width: "100%", gap: "10px"}}>
          <div>{logItem.level.toString()}</div>
          <div>{logItem.type.toString()}</div>
          <div>{logItem.message}</div>
          <div>{logItem.timestamp.toString()}</div>
        </div>
      ))}
    </div>
  )
}
// #endregion

export default function Logbook() {
  const {t} = useTranslation();
  const inputRef=useRef<NewInputListHandles>(null)
  const selectRef=useRef<NewSelectHandles>(null)

  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);

  const {call: FetchLog, data:LogData, deleteEntries:DeleteLogs} = useGetDomainLog() //todo: current LogData is redux and containing both Domain log and LanController log
  const { call: getLanControllers, data: lanControllerData, getLanControllerLogs } = useLanControllers(connection)
  const [viewType, setViewType] = useState<"autoPigLog" | "controllerLog" | "default">("default")
  const [ViewContentBlock, setViewContentBlock] = useState<any|undefined>(<DefaultViewBlock/>)

  useEffect(() => {
    getLanControllers({fetchAmount: 50})  
  }, [])

  useEffect(() => {
    if (LogData && Object.entries(LogData).length) {
      switch (viewType) {
        case "autoPigLog":
          console.log("here 1")
          var AutoPigData = Object.entries(LogData)
          setViewContentBlock(<LogViewBlock LogData={AutoPigData[0]} />);
          break;
        case "controllerLog":
          console.log("here 2")
          var controllerData = Object.entries(LogData)[0][1].data as unknown as LanControllerLogArgs[] //todo: actually evaluate arrays... and correct as typing
          console.log("controllerData", controllerData)
          setViewContentBlock(<ControllerLogViewBlock LogData={controllerData} />);
          break;
        default:
          break;
      }
    }
  }, [viewType, LogData]);

  const lanControllerOptions = useMemo(() => {
    if (lanControllerData && lanControllerData[domain]) {
      return lanControllerData[domain].data?.map(lanController => ({
        label: lanController.name ?? "",
        id: lanController.controller_id
      }))
    }
    return []
  }, [domain, lanControllerData])

  const today = Math.round(Date.now()/1000)
  const weekAgo = today-(7*24*60*60)

  const ClickHandler = (selectedViewType: "autoPigLog" | "controllerLog") => {
    DeleteLogs();
    setViewType(selectedViewType);
  
    if (selectedViewType === "autoPigLog") {
      if (inputRef.current) {
        const gate = inputRef.current.value(0);
        const device = inputRef.current.value(1);
  
        if (gate && device) {
          const parsedGate = Number(gate);
          const parsedDevice = Number(device);
          FetchLog(2, Graph_QL.create({ domain, gate: parsedGate, device: parsedDevice }));
        }
      }
    }
  
    if (selectedViewType === "controllerLog") {
      if (selectRef.current) {
        const lanController = selectRef.current.value?.id;
        if (lanController) {
          const parsedLanController = Number(lanController);
          getLanControllerLogs({ starttime: weekAgo, endtime: today, lancontrollerid: parsedLanController });
        }
      }
    }
  };
  

  return (
    <frames.Page_inner>
    <frames._page_inner_header>
      <PageHeader topHeader={t(`menuHeaders.${Pages.logbook}`, {defaultValue: "logook"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})}/> 
    </frames._page_inner_header>
    <frames._page_inner_content>
      <div style={{height: "100%"}}>
        <div style={{width: "100%", height: "100%", border: "5px solid "+colors.greyPrimary, borderRadius: "10px", boxSizing: "border-box", overflow: "hidden" }}>
          <div style={{display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "40px 1fr", boxSizing: "border-box", height: "100%"}}>
              <div style={{ gridArea: "1/1/2/2", backgroundColor: colors.greyPrimary, display: "flex", alignItems: "center", padding: "0px 20px", borderBottom: "5px solid " + colors.greyPrimary, gap: "5px" }}>
                <NewSelect
                  options={[{label: "AutoPig Log", id: "autoPigLog"}, {label: "controller Log", id: "controllerLog"}]} 
                  placeholder="Select Log Type"
                  fieldOverrides={{
                    fieldStyle: NewFieldStyles.greySecondary,
                    fieldWidth: "137.5px"
                  }}
                  onChange={(e) => { if (e)
                    setViewType(e.id as any)
                  }}
                />
              {viewType === "autoPigLog" ? 
              <NewInputList ref={inputRef}
                placeholders={["GateWay", "Device ID"]}  
                isRequired={[false, false]} 
                fieldOverrides={{
                  fieldStyle: NewFieldStyles.greySecondary,
                  fieldWidth: "137.5px"
                }}
                valueOverrides={{
                  valueTypes: ["number", "number"]
                }}
                listOverrides={{
                  listStyle: ListStyle_Types.horizontal
                }}
              />
              : viewType === "controllerLog" ?
              <NewSelect 
                ref={selectRef}
                options={lanControllerOptions} 
                placeholder="Lan Controllers"
                fieldOverrides={{
                  fieldStyle: NewFieldStyles.greySecondary,
                  fieldWidth: "137.5px"
                }}
              />
              : <></>}
                {viewType === "autoPigLog" || viewType === "controllerLog" ?
                <Button 
                    content={"Get Log"}
                    buttonType={ButtonTypes.textButton}
                    onClick={() => ClickHandler(viewType)}
                  />
              : <></>}
              
              
            </div>
            <div style={{gridArea: "2/1/3/2", backgroundColor: colors.greyLightTertiary, overflowY: "scroll", scrollbarColor: colors.greyTertiary+colors.transparent, height: "100%", scrollbarWidth: "thin", padding: "20px"}}>
              <div style={{height: "fit-content"}}>{ViewContentBlock?ViewContentBlock:<></>}</div>
            </div>
          </div>
          </div>
        </div>
    </frames._page_inner_content>
    </frames.Page_inner>
  )
}